import ModalAccept from './accept';
import ModalDouble from './double';
import ModalFeedback from './feedback';
import ModalPromote from './promote';
import ModalReject from './reject';
import ModalSelo from './selo';
import ModalStop from './stop';
import ModalStopQuiz from './stop-quiz';
import ModalReset from './reset';
import ModalTeamMemberAccept from './team-member-accept';
import ModalTeamMemberReject from './team-member-reject';
import ModalTeamMemberExclude from './team-member-exclude';
import ModalParticipantsReject from './participants-reject';
import ModalParticipantsAccept from './participants-accept';
import ModalTeamMemberDecrease from './team-member-decrease';

interface Props {
  callback: (obj: { [key: string]: any }) => void;
  id: string;
  status?: string;
  data?: any;
  playerInfo?: any;
  validateTeamMember?: string;
  activeEvaluationStep: number;
  bonus?: boolean;
  userToChange?: string;
}

export default function ModalActions(props: Props) {
  const { callback, status, id, data, playerInfo, validateTeamMember, activeEvaluationStep, bonus, userToChange } = props;

  return (
    <>
      <ModalAccept callback={callback} status={status} id={id} data={data} />
      <ModalDouble callback={callback} status={status} id={id} data={data} />
      <ModalFeedback callback={callback} status={status} id={id} data={data} />
      <ModalPromote callback={callback} status={status} id={id} data={data} playerInfo={playerInfo} bonus={bonus} />
      <ModalReject callback={callback} status={status} id={id} data={data} />
      <ModalTeamMemberExclude callback={callback} status={status} id={id} data={data} userToChange={userToChange} />
      <ModalTeamMemberDecrease callback={callback} status={status} id={id} data={data} userToChange={userToChange} />
      <ModalSelo callback={callback} status={status} id={id} data={data} bonus={bonus} />
      <ModalStop callback={callback} status={status} id={id} data={data} />
      <ModalStopQuiz callback={callback} id={id} data={data} playerInfo={playerInfo} />
      <ModalReset callback={callback} data={data} activeEvaluationStep={activeEvaluationStep} />
      <ModalTeamMemberAccept
        callback={callback}
        status={status}
        id={id}
        data={data}
        validateTeamMember={validateTeamMember}
        playerInfo={playerInfo}
      />
      <ModalTeamMemberReject
        callback={callback}
        status={status}
        id={id}
        data={data}
        validateTeamMember={validateTeamMember}
        playerInfo={playerInfo}
      />
      <ModalParticipantsAccept callback={callback} status={status} id={id} data={data} playerInfo={playerInfo} />
      <ModalParticipantsReject callback={callback} status={status} id={id} data={data} playerInfo={playerInfo} />
    </>
  );
}
